/** @jsxImportSource @emotion/react */
import React from 'react';
import styled from '@emotion/styled';
import * as color from '@constant/color';

const Wrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  gap: 12px;
  width: 280px;
  height: 100%;
  padding: 18px;
  border-radius: 8px;
  background-color: ${color.WHITE_1};
  border: 1px solid ${color.GRAY_3};
  box-sizing: border-box;
`;

const Title = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${color.BLACK_2};
  text-align: center;
`;

const Placeholder = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  color: ${color.BLACK_5};
  text-align: center;
  line-height: 1.5;
`;

const VocabularyBookMetricPanel: React.FC = () => {
  return (
    <Wrapper>
      <Title>단어집 지표</Title>
      <Placeholder>
        지표 준비 중
        <br />
        (언어/카테고리/레벨별 분포)
      </Placeholder>
    </Wrapper>
  );
};

export default VocabularyBookMetricPanel;
